module.exports = __webpack_public_path__ + "img/chart1.d731261e.jpg";